import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
} from "@mui/material";

import { useQuery } from "@apollo/client";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
//Srcs
import "../../../Style/pagestyle.scss";
import { GET_AJUST_IN_PAGINATION } from "../../../Schema/Ajustment";
import CreateAjustIn from "./CreateAjustIn";
import { AuthContext } from "../../../Context/AuthContext";
import CreateIcon from "../../../Assets/create-icon.svg";
import EmptyData from "../../../Components/Include/EmptyData";
import FooterPagination from "../../../Components/Include/FooterPagination";
import LoadingPage from "../../../Components/Include/LoadingPage";
import { SelectSupplier } from "../../Include/DynamicSelect";
import { SelectWarehouse } from "../../Include/DynamicSelect";
import ViewAdjInAction from "./ViewAdjInAction";

export default function AjustmentInPage() {
  //=====
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [getAdjDate, setGetAdjDate] = useState();
  const [selectSupplier, setSelectedSupplier] = useState({ id: "", title: "" });
  const [selectWarehouse, setSelectedWarehouse] = useState({
    id: "",
    title: "",
  });

  // 
  const { refetch } = useQuery(GET_AJUST_IN_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      date: getAdjDate ? moment(getAdjDate).format("YYYY-MM-DD") : null,
      supplierId: selectSupplier?.id,
      warehouseId: selectWarehouse?.id,
    },
    onCompleted: ({ getAdjustInPagination }) => {
      // console.log("getAdjustInPagination+;;;", getAdjustInPagination)
      setTableData(getAdjustInPagination?.data);
      setPaginationData(getAdjustInPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      // console.log("Error::", err?.message);
    },
  });
  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };
  //width
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 2000);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  //open Create
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const handleTranslate = (value) => {
    if (value === "free") {
      return "ឥតគិតថ្លៃ";
    } else if (value === "from_use") {
      return "ពីការប្រើប្រាស់"
    } else if (value === "production") {
      return "ផលិត"
    } else if (value === "lack") {
      return "រាប់ខ្វះ"
    } else {
      return value
    }
  }

  return (
    <div className="page-container">
      <Box sx={{ marginTop: "5px" }}>
        <Stack direction="row" marginTop={"-9px"} marginX={"-24px"}>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
              <Typography className="header-text">
                ស្វែងរកអ្នកផ្គត់ផ្គង់
              </Typography>
              <SelectSupplier
                className="search-field"
                selectedVal={selectSupplier}
                setSelectedVal={setSelectedSupplier}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
              <Typography className="header-text">
                ស្វែងរកឃ្លាំងទំនិញ
              </Typography>
              <SelectWarehouse
                className="search-field"
                selectedVal={selectWarehouse}
                setSelectedVal={setSelectedWarehouse}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
              <Typography className="header-text">កាលបរិច្ចេទ</Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  // inputFormat="dd-MM-yyyy"
                  // mask="__.__.____"
                  value={getAdjDate}
                  onChange={(newValue) => {
                    setGetAdjDate(newValue);
                  }}
                  className="search-field"
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                    },
                  }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} sm={6} md={12} lg={3} xl={4.8}>
              <Stack direction="row" justifyContent="right">
                <Button
                  onClick={handleOpen}
                  className="btn-create"
                  startIcon={
                    <img
                      src={CreateIcon}
                      alt="CreateIcon"
                      className="icon-add"
                    />
                  }
                >
                  បង្កើត
                </Button>
                {
                  open &&
                  <CreateAjustIn
                    open={open}
                    handleClose={handleClose}
                    setRefetch={refetch}
                  />
                }
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Box>
      <Box className="body-container" marginTop="30px">
        <Stack direction="row" marginTop={"-9px"} marginX={"-24px"}>
          <TableContainer sx={{ maxWidth: `${width}px` }}>
            <Table className="table" aria-label="simple table">
              <TableHead className="header-row ">
                <TableCell className="header-title-start" width="6%">
                  ល.រ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  កាលបរិច្ចេទចូលស្តុក
                </TableCell>
                <TableCell className="header-title" width="15%">
                  អ្នកផ្គត់ផ្គង់
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ឃ្លាំងទំនិញ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  មូលហេតុ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  អ្នកកែប្រែ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ចំណាំ
                </TableCell>
                <TableCell
                  className="header-title-end"
                  width="17%"
                  align="center"
                >
                  ពិនិត្យ
                </TableCell>
              </TableHead>
              {loading ? (
                <LoadingPage colSpan={8} />
              ) : (
                <>
                  {tableData?.length === 0 ? (
                    <EmptyData colSpan={8} />
                  ) : (
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.dateTime)?.format(
                                "DD-MM-YYYY hh:mm a"
                              )}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.supplierId?.name}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.warehouseId?.warehouseName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {handleTranslate(row?.reason)}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.createdBy?.mainUserId?.lastName +
                                " " +
                                row?.createdBy?.mainUserId?.firstName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.remark}
                            </TableCell>
                            <TableCell className="body-cell-end" align="center">
                              <ViewAdjInAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                </>
              )}
            </Table>
          </TableContainer>
        </Stack>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        />
      </Box>
    </div>
  );
}
